import { z } from 'zod';
import { InvalidArgumentError } from '@commander-js/extra-typings';
import { docsExtensionTypeSchema } from '../components/GenerateCommand/docsExtensionType.js';
import { extensionHandlers } from '../components/GenerateCommand/extensionHandlers.js';
import { developmentSiteTemplateSchema } from '../dev-site-schema.js';

export function validateBase(value: string) {
  const parsed = z.string().url().safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError('Value must be a valid URL');
}

export function validateBasePath(value: string) {
  const parsed = z.string().startsWith('/').safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError('Value must be a pathname starting with "/"');
}

const LABEL_MAX_LENGTH = 200;

export function validateLabel(value: string) {
  const parsed = z.string().max(LABEL_MAX_LENGTH).safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError(
    `Value must be up to ${LABEL_MAX_LENGTH} characters`
  );
}

export function validateReleaseComment(value: string) {
  const parsed = z.string().max(250).safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError(
    'The comment is limited to a maximum of 250 characters'
  );
}

export function validateDocsExtensionType(value: string) {
  const parsed = docsExtensionTypeSchema.safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError('Value must be a valid extension type');
}

export function validateGenerateSchemaExtensionType(value: string) {
  if (Object.hasOwn(extensionHandlers, value)) {
    return value as keyof typeof extensionHandlers;
  }

  throw new InvalidArgumentError('Value must be a valid extension type');
}

export function validateValidJson(rawJson: string) {
  try {
    const jsonObject: Record<string, unknown> = JSON.parse(rawJson);
    return jsonObject;
  } catch {
    throw new InvalidArgumentError('Value must be a valid JSON');
  }
}

export function validateDevelopmentSiteTemplate(value: string) {
  const parsed = developmentSiteTemplateSchema.safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError('Value must be one of: dev, harmony');
}
